import ApiClient from '../utils/apiClient';

class AdminService {
  static instance: AdminService | null = null;

  static getInstance(): AdminService {
    if (!AdminService.instance) {
      AdminService.instance = new AdminService();
    }
    return AdminService.instance;
  }

  // ApiClient wirft bei !ok - null Guards nicht mehr nötig
  async getStatus(): Promise<any> {
    const res = await ApiClient.get('admin/status');
    return res.json();
  }

  async searchUsers(q: string): Promise<any> {
    const res = await ApiClient.get(`admin/search-users?q=${encodeURIComponent(q || '')}`);
    return res.json();
  }

  async startImpersonation(userId: string): Promise<any> {
    const res = await ApiClient.post('admin/impersonate/start', { user_id: userId });
    return res.json();
  }

  async stopImpersonation(): Promise<any> {
    const res = await ApiClient.post('admin/impersonate/stop', {});
    return res.json();
  }

  async armWrite(): Promise<any> {
    const res = await ApiClient.post('admin/write/arm', {});
    return res.json();
  }

  async disarmWrite(): Promise<any> {
    const res = await ApiClient.post('admin/write/disarm', {});
    return res.json();
  }
}

export const adminService = AdminService.getInstance();
